import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Button, Card, DataDisplayPlain, Title } from '@e2n/ui/v2';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Persoenliches() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const data = form.state.values;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2 items-center justify-between">
        <Title className="wrap-break-word">
          {`${data.person.persoenliches.vorname} ${data.person.persoenliches.nachname}`}
        </Title>
        <Button
          iconOnly
          variant={'secondary-red-on-grey'}
          className="bg-neutrals-v2-100"
          onClick={() => ctx.navigateToStep('person')}>
          <FontAwesomeIcon icon={faPen} />
        </Button>
      </div>
      <DataDisplayPlain
        variant="text"
        orientation="vertical"
        label={t('domain.mitarbeiter.create.allgemeinForm.anrede.label')}
        item={data.person.persoenliches.anrede}
      />
      <DataDisplayPlain
        variant="text"
        orientation="vertical"
        label={t(
          'domain.mitarbeiter.create.steps.person.persoenliches.form.rufname.label',
        )}
        item={data.person.persoenliches.rufname || '-'}
      />

      <div className="grid grid-cols-2 gap-4 wrap-anywhere">
        <Card className="bg-backgrounds-secondary outline-neutrals-v2-300 outline-2">
          <DataDisplayPlain
            variant="text"
            orientation="vertical"
            label={t(
              'domain.mitarbeiter.create.steps.person.persoenliches.form.personalnummer.label',
            )}
            item={data.person.persoenliches.personalnummer || '-'}
          />
        </Card>
        <Card className="bg-backgrounds-secondary outline-neutrals-v2-300 outline-2">
          <DataDisplayPlain
            variant="text"
            orientation="vertical"
            label={t(
              'domain.mitarbeiter.create.steps.person.persoenliches.form.e2nId.label',
            )}
            item={data.person.persoenliches.e2nId || '-'}
          />
        </Card>
      </div>
    </div>
  );
}
